import { SparkleIcon } from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';
import { Button } from '@/components/ui/button';
import { useAskWorkbookAgent } from './useAskWorkbookAgent';
import type { RunActionProps } from './workbookIntegrations';

/** Agents' Run action: asks the Workbook's agent to explain one Run. */
export function AskAgentAboutRun({ editor, run }: RunActionProps) {
  const gt = useGT();
  const agent = useAskWorkbookAgent(editor.workbookId);
  const prompt =
    run.status === 'failed'
      ? gt('Why did this run fail, and how do I fix it?', {
          context: 'workbook ask agent about a failed run',
        })
      : gt('Summarize what this run produced and anything that looks off.', {
          context: 'workbook ask agent about a run',
        });
  return (
    <Button
      size="sm"
      variant="ghost"
      className="h-6 px-2 text-xs"
      disabled={!agent.ready || agent.busy}
      onClick={() => void agent.ask(prompt, { runQuestion: { runId: run.id } })}
    >
      <SparkleIcon />
      <T context="workbook ask agent about this run">Ask agent</T>
    </Button>
  );
}
